import angular from 'angular';
import _ from 'lodash';
import template from './template.html';
import logger from '../../../shared/logger';
import { DEFAULT_OFFICE } from '../../office-list';
import './style.scss';
import { positionStatuses } from '../../../constants/position';

export class RecruiterPositions {
    loading = false;
    isLoadingPositionsTable = false;
    isLoadingNextPage = false;
    isListLoadingComplete = false;

    tableId = 'recruiterTableToolbar';

    pageOptions = {
        page: 0,
        size: 50,
    };

    sortState = {
        columnName: 'positionDetails.created',
        asc: true,
    };

    positionsToDisplay = [];
    totalPositionsToDisplayCount = 0;

    /* @ngInject */
    constructor(
        $window,
        $scope,
        $filter,
        RecruiterService,
        JobListingLineChart,
        PositionService,
        EmployerService,
        CommonCodeService,
        $localStorage,
        $state,
        $stateParams,
        JobListingAreaChart,
        $timeout,
        TimeLineService,
        WorkflowService,
        RecruiterWorkflowStepResolver,
        EmployerWorkflowStepResolver,
        EMPLOYER_WORKFLOW_STATUS,
        EnvSettings,
        WebAppRouteService,
    ) {
        const recruiterPositionCtrl = this;
        this.$localStorage = $localStorage;
        this.$state = $state;
        this.$scope = $scope;
        this.$stateParams = $stateParams;
        this.$timeout = $timeout;
        this.$filter = $filter;
        this.PositionService = PositionService;
        this.RecruiterService = RecruiterService;
        this.CommonCodeService = CommonCodeService;
        this.RecruiterWorkflowStepResolver = RecruiterWorkflowStepResolver;
        this.EmployerWorkflowStepResolver = EmployerWorkflowStepResolver;
        this.EnvSettings = EnvSettings;
        this.WebAppRouteService = WebAppRouteService;

        this.$scope.positionStatuses = positionStatuses;

        this.filterState = {
            searchValue: '',
            dateValue: _.get($localStorage, 'filterDatePosted', '60_DAYS'),
            projectStatusValue: 'Active',
            showJobProgressState: false,
            blnShowJobProgression: false,
            modeValue: _.get($localStorage, 'filterMode', 'TALENT_EXPERT_MODE'),
        };

        this.startLoading = () => this.loading = true;
        this.stopLoading = () => $timeout(() => this.loading = false);

        this.startPositionsTableLoading = () => this.isLoadingPositionsTable = true;
        this.stopPositionsTableLoading = () => $timeout(() => this.isLoadingPositionsTable = false);

        this.startNextPageLoading = () => this.isLoadingNextPage = true;
        this.stopNextPageLoading = () => $timeout(() => this.isLoadingNextPage = false);

        recruiterPositionCtrl.init = async () => {
            $scope.EMPLOYER_WORKFLOW_STATUS = EMPLOYER_WORKFLOW_STATUS;
            recruiterPositionCtrl.viewMode = this.filterState.modeValue;
            recruiterPositionCtrl.filterByEmployerName = this.filterState.searchValue;
            recruiterPositionCtrl.filterDatePosted = this.filterState.dateValue;
            recruiterPositionCtrl.projectsStatusFilter = this.filterState.projectStatusValue;

            recruiterPositionCtrl.openPositions = [];

            const activeOffice = $localStorage.activeOffice || DEFAULT_OFFICE;
            const params = {
                recruiterId: $stateParams.recruiterId,
                office: activeOffice,
            };

            recruiterPositionCtrl.startLoading();

            try {
                const [
                    { result: openPositions = recruiterPositionCtrl.openPositions } = {},
                    { positions, pageInfo },
                    { finishedTarget: target, options },
                ] = await Promise.all([
                    RecruiterService.getOpenPositions(params),
                    recruiterPositionCtrl.fetchPositions({
                        recruiterId: $stateParams.recruiterId,
                        filters: recruiterPositionCtrl.filterState,
                        sort: recruiterPositionCtrl.sortState.asc ? 'asc' : 'desc',
                    }),
                    JobListingLineChart.getJobListingLineChart(),
                ]);

                recruiterPositionCtrl.openPositions = openPositions;
                recruiterPositionCtrl.positionsToDisplay = positions || [];
                recruiterPositionCtrl.totalPositionsToDisplayCount = _.get(pageInfo, '[0].count', 0);
                recruiterPositionCtrl.isListLoadingComplete = this.totalPositionsToDisplayCount === this.positionsToDisplay.length;

                recruiterPositionCtrl.extendPositionData(recruiterPositionCtrl.positionsToDisplay);
                recruiterPositionCtrl.initOpenPositions();
                recruiterPositionCtrl.initScrollListener();
                recruiterPositionCtrl.jobListingLineCart(target, options);
            } catch (err) {
                logger.error(err);
            } finally {
                recruiterPositionCtrl.stopLoading();
            }
        };

        recruiterPositionCtrl.fetchMorePositionsIfNeeded = _.debounce(() => {
            if (recruiterPositionCtrl.isLoadingNextPage || recruiterPositionCtrl.isListLoadingComplete) {
                return;
            }
            const windowHeight = 'innerHeight' in window ? window.innerHeight : document.documentElement.offsetHeight;
            const jobsTable = angular.element('.dashboard-job-lisitng') && angular.element('.dashboard-job-lisitng')[0];

            if (!jobsTable) {
                return;
            }

            const jobsTableHeight = jobsTable.offsetHeight;
            const windowBottom = windowHeight + window.pageYOffset;
            if (windowBottom >= jobsTableHeight) {
                recruiterPositionCtrl.fetchMore();
            }
        }, 200);

        recruiterPositionCtrl.initScrollListener = function () {
            angular.element($window).off('scroll');
            angular.element($window).on('scroll', recruiterPositionCtrl.fetchMorePositionsIfNeeded);
        };

        recruiterPositionCtrl.extendPositionData = async function (positions = []) {
            for (const position of positions) {
                position.positionStatus =
                    _.find(recruiterPositionCtrl.recruiterCtrl.recruiterData.positions,
                        { positionId: position.positionId });

                if (position.positionDetails) {
                    position.positionDetails.locationData = this.CommonCodeService.getLocationData(position.positionDetails);
                    position.positionDetails.isPositionGdprCompliant = await PositionService.checkIfPositionIsGdprCompliant(position.positionDetails);
                    if (position.positionDetails.isPositionGdprCompliant) {
                        position.positionDetails.gdprTooltip = `<span><div>${$filter('translate')('GDPR_LOCATION_ICON_TOOLTIP_TEXT')}</div></span>`;
                    }
                }
                position.checkBoxId = position.positionId;
            }
        };

        recruiterPositionCtrl.initOpenPositions = function () {
            recruiterPositionCtrl.openPositions = _.map(recruiterPositionCtrl.openPositions, (position) => {
                if (_.find(recruiterPositionCtrl.recruiterCtrl.recruiterData.positions, {
                    positionId: position._id,
                    reason: 'Hidden',
                })) {
                    position.hidden = true;
                }
                return position;
            });
            for (const position of recruiterPositionCtrl.openPositions) {
                position.locationData = this.CommonCodeService.getLocationData(position);
            }
        };

        recruiterPositionCtrl.jobListingLineCart = function (target, options) {
            const positionArray = _.map(recruiterPositionCtrl.positionsToDisplay, 'positionId');

            if (positionArray.length === 0) {
                return;
            }

            recruiterPositionCtrl.finishedTarget = { target };
            recruiterPositionCtrl.jobListingLineChartResponseOptions = options;
            recruiterPositionCtrl.originalDataSource = angular.copy(recruiterPositionCtrl.jobListingLineChartResponseOptions.dataSource);
            recruiterPositionCtrl.dataEnteredByPositionId = JobListingLineChart.getJobListingData();
            angular.forEach(recruiterPositionCtrl.positionsToDisplay, (position) => {
                recruiterPositionCtrl.createJobListingAreaChart(position);
            });

            recruiterPositionCtrl.stopLoading();
            $timeout(() => recruiterPositionCtrl.loadAndApplySortAndFilter());
        };

        recruiterPositionCtrl.goToPositionState = function (positionId, state) {
            $localStorage[positionId] = null;
            $state.go('recruiter.candidatesJob', {
                positionId,
                scroll: 0,
                currCandidatePage: 1,
                candidate: null,
                workflowStep: state,
            });
        };

        recruiterPositionCtrl.updateLastRow = function (mode) {
            if (mode !== 'Employer') {
                const lastRow = {
                    claimed: 0,
                    engaged: 0,
                    ready: 0,
                    sent: 0,
                    hired: 0,
                    rejected: 0,
                    month: 0,
                    placementFee: 0,
                };

                if (recruiterPositionCtrl.positionsToDisplay && recruiterPositionCtrl.positionsToDisplay.length > 0) {
                    let count = 0;
                    for (let i = 0; i < recruiterPositionCtrl.positionsToDisplay.length; i++) {
                        const recruiterPosition = recruiterPositionCtrl.positionsToDisplay[i];
                        count++;
                        lastRow.claimed += recruiterPosition.positionClaimed;
                        lastRow.engaged += recruiterPosition.positionEngaged;
                        lastRow.ready += recruiterPosition.positionReady;
                        lastRow.sent += recruiterPosition.positionSent;
                        lastRow.hired += recruiterPosition.positionHired;
                        lastRow.rejected += recruiterPosition.positionRejected;
                        if (recruiterPosition.positionDetails &&
                            recruiterPosition.positionDetails.created) {
                            lastRow.month += $filter('calculateMonthPostedDays')(recruiterPosition.positionDetails.created, 'dd/MM/yy');
                        }
                        lastRow.placementFee += _.get(recruiterPosition, 'positionDetails.placementFee.sum', 0);
                    }
                    lastRow.month /= count;
                    lastRow.placementFee = Math.round(lastRow.placementFee / count);
                }

                recruiterPositionCtrl.lastRow = lastRow;
            } else {
                const lastRow = {
                    rate: 0,
                    contact: 0,
                    claimed: 0,
                    interviews: 0,
                    hired: 0,
                    rejected: 0,
                    posted: 0,
                };

                if (recruiterPositionCtrl.positionsToDisplay && recruiterPositionCtrl.positionsToDisplay.length > 0) {
                    let count = 0;
                    for (let i = 0; i < recruiterPositionCtrl.positionsToDisplay.length; i++) {
                        const position = recruiterPositionCtrl.positionsToDisplay[i];
                        count++;
                        lastRow.rate += position.positionRate;
                        lastRow.contact += position.positionContact;
                        lastRow.claimed += position.positionClaimed;
                        lastRow.interviews += position.positionInterview;
                        lastRow.hired += position.positionHired;
                        lastRow.rejected += position.positionRejected;
                        if (position.positionDetails &&
                            position.positionDetails.created) {
                            lastRow.posted += $filter('calculateMonthPostedDays')(position.positionDetails.created, 'dd/MM/yy');
                        }
                    }

                    lastRow.posted /= count;
                }


                recruiterPositionCtrl.lastRow = lastRow;
            }
        };

        TimeLineService.timeline(recruiterPositionCtrl);
    }

    async openPosition(position) {
        const {
            $localStorage,
            $state,
            $stateParams: {
                recruiterId,
            },
            RecruiterWorkflowStepResolver,
        } = this;
        const status = _.get(position, 'positionDetails.status');
        const positionId = position.positionId;

        $localStorage.recruiterPosition = angular.copy(position);

        if ([positionStatuses.ACTIVE, positionStatuses.CANCELLED, positionStatuses.FINISHED, positionStatuses.READY].includes(status)) {
            const workflowStep = await RecruiterWorkflowStepResolver.getWorkflowStep(positionId, recruiterId);

            $localStorage.positionData = null;

            $state.go('recruiter.candidatesJob', {
                positionId,
                scroll: 0,
                currCandidatePage: 1,
                candidate: null,
                workflowStep,
            });
        } else if (status === 'Cancelled') {
            $localStorage[positionId] = null;

            $state.go('recruiter.candidatesJob', {
                positionId,
                scroll: 0,
                currCandidatePage: 1,
                candidate: null,
                workflowStep: 2,
            });
        }
    }

    async goToEmployerPositionState(position, state) {
        const { EmployerWorkflowStepResolver } = this;
        const employerId = position.employerDetails.id;
        const positionId = position.positionId;

        if (!state) {
            const workflowStep = await EmployerWorkflowStepResolver.getWorkflowStep(positionId, employerId);

            return this.WebAppRouteService.goToEmployerCandidatesPage({
                employerId,
                positionId,
                workflowStep,
            });
        }

        return this.WebAppRouteService.goToEmployerCandidatesPage({
            employerId,
            positionId,
            workflowStep: state,
        });
    }

    loadAndApplySortAndFilter() {
        this.loadFilterState();
        this.loadSortState();
        this.applyFilter(this.filterState);
    }

    async onFilterStateChange(filterState) {
        try {
            const { dateValue, projectStatusValue, modeValue, searchValue = '' } = filterState;

            if (
                this.filterDatePosted !== dateValue
                || this.projectsStatusFilter !== projectStatusValue
                || this.viewMode !== modeValue
                || _.get(this, 'filterByEmployerName', '') !== searchValue
            ) {
                this.filterState = filterState;
                this.startPositionsTableLoading();
                await this.fetchFirstPage();
            }

            this.applyFilter(filterState);

            const self = this;
            this.$timeout(() => {
                self.$scope.$apply();
            });
        } catch (e) {
            logger.error(e);
        } finally {
            this.stopPositionsTableLoading();
        }
    }

    async fetchFirstPage() {
        const { positions, pageInfo } = await this.fetchPositions({
            recruiterId: this.$stateParams.recruiterId,
            filters: this.filterState,
            sort: this.sortState.asc ? 'asc' : 'desc',
        });

        this.pageOptions.page = 1;

        this.positionsToDisplay = positions;
        this.totalPositionsToDisplayCount = _.get(pageInfo, '[0].count', 0);
        this.isListLoadingComplete = this.totalPositionsToDisplayCount === this.positionsToDisplay.length;

        this.extendPositionData(positions);
    }

    applyFilter({ searchValue, dateValue, projectStatusValue, showJobProgressState, modeValue }) {
        this.$localStorage.filterMode = modeValue;
        this.$localStorage.filterDatePosted = dateValue;

        this.filterByEmployerName = searchValue;
        this.filterDatePosted = dateValue;
        this.projectsStatusFilter = projectStatusValue;
        this.blnShowJobProgression = showJobProgressState;
        this.viewMode = modeValue;
    }

    async fetchPositions(params) {
        params.filters = _.pick(
            params.filters,
            ['dateValue', 'projectStatusValue', 'modeValue', 'searchValue'],
        );
        try {
            const response = await this.RecruiterService.getPositions(params);
            return _.get(response, 'result', []);
        } catch (err) {
            logger.error(err);
        }
    }

    async fetchMore() {
        try {
            if (this.isLoadingNextPage || this.isListLoadingComplete) {
                return;
            }
            this.startNextPageLoading();
            const { positions, pageInfo } = await this.fetchPositions({
                recruiterId: this.$stateParams.recruiterId,
                filters: this.filterState,
                pageOptions: {
                    page: this.pageOptions.page + 1,
                    size: this.pageOptions.size,
                },
            });
            this.extendPositionData(positions);
            this.positionsToDisplay = [
                ...this.positionsToDisplay,
                ...positions,
            ];
            this.totalPositionsToDisplayCount = _.get(pageInfo, '[0].count', 0);
            this.isListLoadingComplete =
                this.totalPositionsToDisplayCount === this.positionsToDisplay.length
                || _.isEmpty(positions);

            this.pageOptions.page += 1;
            this.$scope.$apply();
        } catch (e) {
            logger.error(e);
        } finally {
            this.stopNextPageLoading();
        }
    }


    // TODO: create table component and move sorting logic there
    get storage() {
        return this.$localStorage;
    }

    onSortStateChange(sortState) {
        this.sortState = sortState;
    }

    async onPostedColumnClick() {
        if (this.isListLoadingComplete) {
            const sortState = this.sortState;
            this.sortState.asc = !this.sortState.asc;
            this.saveSortState(sortState);
            this.onSortStateChange(sortState);
        } else {
            this.sortState.asc = !this.sortState.asc;
            this.startPositionsTableLoading();
            await this.fetchFirstPage();
            this.stopPositionsTableLoading();
        }
    }

    loadFilterState() {
        const tableState = this.storage[this.tableId];

        if (tableState) {
            const { filterState } = this.storage[this.tableId];

            if (filterState) {
                this.onFilterStateChange(filterState);
            }
        }
    }

    loadSortState() {
        const tableState = this.storage[this.tableId];

        if (tableState) {
            const { sortState } = this.storage[this.tableId];

            if (sortState) {
                this.onSortStateChange(sortState);
            }
        }
    }

    saveSortState(sortState) {
        const tableState = this.storage[this.tableId];

        if (tableState) {
            tableState.sortState = sortState;
        } else {
            this.storage[this.tableId] = { sortState };
        }
    }
}

export const RecruiterPositionsConfiguration = {
    template,
    require: {
        recruiterCtrl: '^recruiterComponent',
    },
    controller: RecruiterPositions,
    controllerAs: 'ctrl',
};

angular
    .module('TALENYA-FE')
    .component('recruiterPositionsComponent', RecruiterPositionsConfiguration);
